import React, { useState } from 'react';
import { COLORS } from '../../theme';

const AdSettingsEditor = ({ adConfig, setAdConfig }) => {
    const [isOpen, setIsOpen] = useState(false);

    // 設定更新用ヘルパー
    const updateConfig = (key, value) => {
        setAdConfig(prev => ({ ...prev, [key]: value }));
    };

    return (
        <div style={{marginBottom:'20px', border:'1px solid #ddd', borderRadius:'8px', background:'white', overflow:'hidden'}}>
            <div 
                onClick={() => setIsOpen(!isOpen)} 
                style={{
                    padding:'15px', background:'#e3f2fd', cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', fontWeight:'bold', color:'#0d47a1'
                }}
            >
                <span>📢 広告・アフィリエイト設定</span>
                <span>{isOpen ? '▲ 閉じる' : '▼ 開く'}</span>
            </div>
            
            {isOpen && (
                <div style={{padding:'15px'}}>
                    
                    {/* 有効化スイッチ */}
                    <div style={{marginBottom:'15px', padding:'10px', background:'#f1f8e9', borderRadius:'8px', border:'1px solid #c5e1a5'}}>
                        <label style={{fontWeight:'bold', display:'flex', alignItems:'center', cursor:'pointer', color:'#33691e'}}>
                            <input 
                                type="checkbox" 
                                checked={adConfig.enabled} 
                                onChange={e => updateConfig('enabled', e.target.checked)} 
                                style={{width:'auto', marginRight:'8px', transform:'scale(1.2)'}} 
                            />
                            広告バナーを有効にする (アプリ最下部に表示)
                        </label>
                    </div>
                    
                    {/* 入力フォーム */}
                    <div style={{background:'#f9f9f9', padding:'15px', borderRadius:'8px', marginBottom:'20px'}}>
                        <div style={{marginBottom:'15px'}}>
                            <label style={{display:'block', fontSize:'12px', fontWeight:'bold', marginBottom:'5px'}}>バナー画像 URL</label>
                            <input 
                                type="text" 
                                value={adConfig.imageUrl} 
                                onChange={e => updateConfig('imageUrl', e.target.value)} 
                                placeholder="https://.../banner.jpg" 
                                style={{width:'100%', padding:'8px', boxSizing:'border-box'}}
                            />
                        </div>
                        <div style={{marginBottom:'15px'}}>
                            <label style={{display:'block', fontSize:'12px', fontWeight:'bold', marginBottom:'5px'}}>リンク先 URL</label>
                            <input 
                                type="text" 
                                value={adConfig.linkUrl} 
                                onChange={e => updateConfig('linkUrl', e.target.value)} 
                                placeholder="https://..." 
                                style={{width:'100%', padding:'8px', boxSizing:'border-box'}}
                            />
                        </div>
                        <div style={{marginBottom:'10px'}}>
                            <label style={{display:'block', fontSize:'12px', fontWeight:'bold', marginBottom:'5px'}}>PRテキスト</label>
                            <input 
                                type="text" 
                                value={adConfig.text} 
                                onChange={e => updateConfig('text', e.target.value)} 
                                placeholder="例: 今なら入会金無料キャンペーン中！" 
                                style={{width:'100%', padding:'8px', boxSizing:'border-box'}}
                            />
                        </div>
                    </div>

                    {/* --- リアルタイムプレビュー --- */}
                    <div style={{border:'2px dashed #ccc', borderRadius:'8px', padding:'10px', background:'#eee'}}>
                        <div style={{fontSize:'12px', color:'#666', marginBottom:'5px', textAlign:'center', fontWeight:'bold'}}>
                            📱 アプリ表示プレビュー {adConfig.enabled ? <span style={{color:'green'}}>(ON)</span> : <span style={{color:'red'}}>(OFF)</span>}
                        </div>
                        
                        {/* 擬似スマホ画面 */}
                        <div style={{
                            width:'100%', maxWidth:'350px', height:'100px', margin:'0 auto', 
                            background:'white', position:'relative', border:'1px solid #ddd', 
                            overflow:'hidden', display:'flex', alignItems:'flex-end'
                        }}>
                            {/* コンテンツのダミー (背景) */}
                            <div style={{position:'absolute', top:0, left:0, right:0, bottom:0, padding:'10px', opacity:0.3, filter:'blur(1px)'}}>
                                <div style={{height:'10px', background:'#ddd', marginBottom:'5px', width:'80%'}}></div>
                                <div style={{height:'10px', background:'#ddd', marginBottom:'5px', width:'60%'}}></div>
                                <div style={{height:'10px', background:'#ddd', marginBottom:'5px', width:'90%'}}></div>
                            </div>

                            {/* ★修正: enabledに関わらず常にプレビューを表示 */}
                            <div style={{
                                width:'100%', background:'rgba(255,255,255,0.95)', borderTop:'1px solid #eee', 
                                padding:'10px', boxSizing:'border-box', display:'flex', alignItems:'center', 
                                gap:'10px', boxShadow:'0 -2px 5px rgba(0,0,0,0.05)', position:'relative', zIndex:10
                            }}>
                                {adConfig.imageUrl ? (
                                    <img src={adConfig.imageUrl} style={{width:'50px', height:'50px', objectFit:'cover', borderRadius:'8px', border:'1px solid #eee'}} alt="ad" />
                                ) : (
                                    <div style={{width:'50px', height:'50px', background:'#eee', borderRadius:'8px', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'20px'}}>📷</div>
                                )}
                                <div style={{flex:1, minWidth:0}}>
                                    <div style={{fontSize:'10px', color:'#999', marginBottom:'2px'}}>PR</div>
                                    <div style={{fontSize:'12px', fontWeight:'bold', color:'#333', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>
                                        {adConfig.text || 'テキスト未入力'}
                                    </div>
                                </div>
                                <button className="btn btn-sm" style={{
                                    background: COLORS?.secondary || '#ffb300', 
                                    color:'#000', borderRadius:'20px', border:'none', 
                                    padding:'5px 12px', fontSize:'11px', fontWeight:'bold', whiteSpace:'nowrap'
                                }}>
                                    詳細
                                </button>
                            </div>
                        </div>
                        
                        {/* OFFの場合の注釈 */}
                        {!adConfig.enabled && (
                            <div style={{textAlign:'center', fontSize:'10px', color:'#d32f2f', marginTop:'5px', fontWeight:'bold'}}>
                                ※現在は「無効」設定のため、実際のアプリには表示されません
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdSettingsEditor;